import { Stack, Tabs } from '@mantine/core'
import React from 'react'
import type { EditableSkill } from './lessonCounts'
import LessonManagementPanel from './LessonManagementPanel'
import SpeakingDailyTopics from './SpeakingDailyTopics'

type SpeakingTabPanelProps = {
	/** The SPEAKING course; the Speaking tab is open only when there is one. */
	courseId: string
	onLessonCount?: (skill: EditableSkill, count: number) => void
}

const innerTabsStyles = {
	'.mantine-Tabs-list': { gap: 8, paddingBottom: 6, flexWrap: 'wrap' as const },
	'.mantine-Tabs-tab': { fontWeight: 600, color: '#374151', borderRadius: 8 },
	'.mantine-Tabs-tab[data-active="true"]': {
		color: '#1f7a44',
		background: '#ecfdf3',
	},
}

/**
 * The Speaking tab of Manage Lessons (UD-671): the Basic UniVini lessons, written like Writing and Listening
 * lessons, and the topics of each date (Basic UniVini, Hot topic, IELTS) that learners are offered.
 */
function SpeakingTabPanel({ courseId, onLessonCount }: SpeakingTabPanelProps) {
	return (
		<Stack spacing="sm">
			<Tabs defaultValue="lessons" keepMounted={false} sx={innerTabsStyles}>
				<Tabs.List>
					<Tabs.Tab value="lessons">Lessons</Tabs.Tab>
					<Tabs.Tab value="daily">Daily topics</Tabs.Tab>
				</Tabs.List>
				<Tabs.Panel value="lessons" pt="sm">
					<LessonManagementPanel
						skill="speaking"
						onLessonCount={onLessonCount}
					/>
				</Tabs.Panel>
				<Tabs.Panel value="daily" pt="sm">
					<SpeakingDailyTopics courseId={courseId} />
				</Tabs.Panel>
			</Tabs>
		</Stack>
	)
}

export default SpeakingTabPanel
